










































import Vue from 'vue';
import ApiConfiguration from '@/classes/ApiConfiguration';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import { confirmationHelper } from '@/mixins/confirmationHelper';
import { FormFieldValidation } from '@/mixins/formValidation';
import MStoreForm from '@/components/shared/MStoreForm.vue';
import MStoreFormInput from '@/components/shared/MStoreFormInput.vue';
import MStoreSpinnerButton from '@/components/shared/MStoreSpinnerButton.vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import { SweepFolderDefaultsModel } from '@/services/GeneratedApi';
import { mapGetters, mapActions } from 'vuex';

export default Vue.extend({
  name: 'SweepFolderDefaultsModal',
  mixins: [confirmationHelper, FormFieldValidation],
  components: {
    MStoreForm,
    MStoreFormInput,
    MStoreSpinnerButton,
    LoadingSpinner
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      isVisible: this.visible,
      isSubmitting: false,
      isLoading: false,
      localDefaults: {} as SweepFolderDefaultsModel
    };
  },
  computed: {
    ...mapGetters('applicationDirtyStore', ['isApplicationDirty'])
  },
  methods: {
    ...mapActions('applicationDirtyStore', ['setApplicationDirty']),
    async loadDefaults(this: any) {
      this.isLoading = true;
      try {
        const response: SweepFolderDefaultsModel = await ApiConfiguration.apiWithErrorPage().sweepFileSourceConfiguration.sweepFileSourceConfigurationDefaultsList();
        this.localDefaults = { ...response };
      } catch (error) {
        this.$log(error);
        SnotifyConfiguration.showError('Failed to load sweep defaults');
      } finally {
        this.isLoading = false;
      }
    },
    async onSubmitAsync(this: any) {
      const isValid = await this.$refs.form.$refs.ValidationObserver.validate();
      if (!isValid) {
        return;
      }

      this.isSubmitting = true;
      try {
        await ApiConfiguration.apiWithErrorPage().sweepFileSourceConfiguration.sweepFileSourceConfigurationDefaultsUpdate(this.localDefaults);
        this.setApplicationDirty(false);
        this.$emit('saved');
        this.isVisible = false;
      } catch (error) {
        this.$log(error);
        SnotifyConfiguration.showError('Failed to save sweep defaults');
      } finally {
        this.isSubmitting = false;
      }
    },
    async onCancel(this: any) {
      const hasUnsavedChangesToKeep: boolean = await this.hasUnsavedChangesToKeepAsync(this.$bvModal, this.isApplicationDirty);
      if (hasUnsavedChangesToKeep) {
        return;
      }
      this.setApplicationDirty(false);
      this.isVisible = false;
      this.$emit('cancel');
    }
  },
  async mounted(this: any) {
    await this.loadDefaults();
  }
});
